import { CustomFieldsFieldTypeEnum } from 'generated/resources/graphql'

export const getValueType = (fieldType: CustomFieldsFieldTypeEnum) => {
  switch (fieldType) {
    case 'text':
      return 'string'

    case 'cents':
    case 'money':
      return 'cents'

    case 'date':
      return 'date'

    case 'long_text':
      return 'string'

    case 'checkbox':
      return 'boolean'

    case 'single_choice':
    case 'multiple_choice':
      return 'string'

    case 'rating':
      return 'number'

    default:
      const exhaustiveCheck: never = fieldType
      throw new Error(`Unknown field type: ${exhaustiveCheck}`)
  }
}
